import { View } from 'react-native'
import { HomeBrowseTabs } from '~/components/feed/HomeBrowseTabs'
import { HomeFeedStack } from '~/components/feed/HomeFeedStack'
import { useHomeFeedStack } from '~/data/feed/useHomeFeedStack'

export function FeedSection({ initialView }: { initialView?: 'leads' | 'assets' }) {
  const homeFeedStack = useHomeFeedStack()

  return (
    <View className="gap-6">
      <HomeFeedStack stack={homeFeedStack} />
      <View>
        <HomeBrowseTabs
          assetCount={homeFeedStack.assetCount}
          initialView={initialView}
          leadCount={homeFeedStack.leadCount}
        />
      </View>
    </View>
  )
}
